/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { Component } from 'react';

import { StepIcon } from '@opendoor/bricks/deprecated/UNSAFE_Timeline';
import { colors } from '@opendoor/bricks/theme/eero';
import classNames from 'classnames';

import styles from './HorizontalTimelineStyle.less';

export interface IHorizontalTimelineStep {
  label?: string;
  isStepCompleted?: boolean;
}

export interface IHorizontalTimelineProps {
  steps: Array<IHorizontalTimelineStep>;
  style?: 'urgent';
}

export interface IStepProps {
  label?: string;
  marker: React.ReactNode;
}

export default class HorizontalTimeline extends Component<IHorizontalTimelineProps> {
  public render() {
    const { steps, style } = this.props;

    return (
      <ul
        className={`${styles['od-horizontal-timeline']}  ${
          style ? `${styles[`od-horizontal-timeline-style-${style}`]}` : ''
        }`}
      >
        {steps.map((step, idx, stepsToShow) => {
          const isPrevCompleted = !!(stepsToShow[idx - 1] || {}).isStepCompleted;
          const isNext = !step.isStepCompleted && (idx === 0 || isPrevCompleted);
          const marker = this.getStatusMarker(!!step?.isStepCompleted, isNext, isPrevCompleted);

          return <Step label={step.label} key={idx} marker={marker} />;
        })}
      </ul>
    );
  }

  private getStatusMarker = (isCompleted: boolean, isNext: boolean, isPrevComplete: boolean) => {
    const { style } = this.props;
    let titleText = 'step icon';

    if (isCompleted) {
      titleText = 'checkmark icon';
    } else if (isNext) {
      titleText = 'empty circle icon';
    } else {
      titleText = 'solid circle icon';
    }

    return (
      <div
        className={classNames(`${styles['od-horizontal-timeline__marker-container']}`, {
          [styles['od-horizontal-timeline__marker--complete']!]: isCompleted, // fill green
          [styles['od-horizontal-timeline__marker--next']!]: isNext,
          [styles['od-horizontal-timeline__marker--prev-complete']!]: isPrevComplete,
        })}
      >
        <div className={`${styles['od-horizontal-timeline__marker']}`}>
          <StepIcon
            isCompleted={isCompleted}
            titleText={titleText}
            fillColor={style === 'urgent' ? colors.red50 : colors.green50}
          />
        </div>
      </div>
    );
  };
}

export const Step: React.FC<IStepProps> = (props: IStepProps) => {
  const { label, marker } = props;

  return (
    <li className={`${styles['od-horizontal-timeline__step']}`}>
      <div
        className={classNames(
          'delay-200ms',
          'scrolled',
          `${styles['od-horizontal-timeline__step-container']}`,
        )}
      >
        <div className={`${styles['od-horizontal-timeline__step-content']}`}>
          {label && (
            <div className={`${styles['od-horizontal-timeline__step-label']}`}>{label}</div>
          )}
        </div>
      </div>
      {marker}
    </li>
  );
};
